export const CallConstants = {
  MODE: {
    DEFAULT: 'DEFAULT',
    SPOTLIGHT: 'SPOTLIGHT',
    // SINGLE: "SINGLE",
    GRID: 'TILE',
    // GRID: "GRID",
  },
  CALL_TYPE: {
    AUDIO: 'audio',
    VIDEO: 'video',
  },
  RECEIVER_TYPE_GROUP: 'group',
  RECEIVER_TYPE_USER: 'user',

  CALL_KEYS: {
    CALL_DATA: 'data',
    CALL_ID: 'id',
    CALL_SESSION_ID: 'sessionid',
    CALL_RECEIVER: 'receiver',
    CALL_INITIATOR: 'initiator',
    CALL_SENDER: 'sender',
    CALL_RECEIVER_TYPE: 'receiverType',
    CALL_STATUS: 'status',
    CALL_TYPE: 'type',
    CALL_INITIATED_AT: 'initiatedAt',
    CALL_JOINED_AT: 'joinedAt',
    CALL_LEFT_AT: 'leftAt',
    CALL_METADATA: 'metadata',
    CALL_ENTITIES: 'entities',
    CALL_ENTITY_TYPE: 'entityType',
    CALL_ENTITY: 'entity',
    CALL_ENTITY_USER: 'user',
    CALL_ENTITY_GROUP: 'group',
  },
  CALL_STATUS: {
    INITIATED: 'initiated',
    ONGOING: 'ongoing',
    UNANSWERED: 'unanswered',
    REJECTED: 'rejected',
    BUSY: 'busy',
    CANCELLED: 'cancelled',
    ENDED: 'ended',
  },
  AUDIO_INPUT_DEVICES: 'audioInputDevices',
  AUDIO_OUTPUT_DEVICES: 'audioOutputDevices',
  VIDEO_INPUT_DEVICES: 'videoInputDevices',
  POST_MESSAGES: {
    TYPES: {
      ACTION_MESSAGE: 'cometchat_action_message',
      HANGUP: 'hangup',
      COMETCHAT_RTC_SETTINGS: 'cometchat_rtc_settings',
    },
    ACTIONS: {
      USER_JOINED: 'onUserJoined',
      USER_LEFT: 'onUserLeft',
      USER_LIST_CHANGED: 'onUserListChanged',
      INITIAL_DEVICE_LIST: 'initialDeviceList',
      DEVICE_CHANGE: 'onDeviceChange',
      LOAD: 'LOAD',
      CHANGE_AUDIO_INPUT: 'changeAudioInput',
      CHANGE_AUDIO_OUTPUT: 'changeAudioOutput',
      CHANGE_VIDEO_INPUT: 'changeVideoInput',
      MUTE_AUDIO: 'muteAudio',
      UNMUTE_AUDIO: 'unmuteAudio',
      PAUSE_VIDEO: 'pauseVideo',
      UNPAUSE_VIDEO: 'unPauseVideo',
      SWITCH_MODE: 'switchMode',
      START_SCREENSHARE: 'startScreenShare',
      STOP_SCREENSHARE: 'stopScreenShare',
      END_CALL: 'endCall',
      START_RECORDING: 'startRecording',
      STOP_RECORDING: 'stopRecording',
      RECORDING_TOGGLED: 'onRecordingToggled',
      USER_MUTED: 'onUserMuted',
      ON_USER_UNMUTED: 'onUserUnMuted',
      SCREEN_SHARE_STARTED: 'SCREEN_SHARE_STARTED',
      SCREEN_SHARE_STOPPED: 'SCREEN_SHARE_ENDED',
      SWITCH_TO_VIDEO_CALL: 'switchedToVideo',
      SWITCHED_TO_VIDEO_CALL: 'onCallSwitchedToVideo',
      OPEN_VIRTUAL_BACKGROUND: 'openVirtualBackgroundMenu',
      SET_BACKGROUND_BLUR: 'setBackgroundBlur',
      SET_BACKGROUND_IMAGE: 'setBackgroundImage',
    },
  },
  MEDIA_DEVICE: {
    ID: 'id',
    NAME: 'name',
    ACTIVE: 'active',
  },
  ZOOM_BUTTON_DEFAULT_PARAMS: {
    position: 'bottom-right',
    visible: true,
  },
  NAME_LABEL_DEFAULT_PARAMS: {
    position: 'bottom-left',
    visible: true,
    color: 'rgba(27, 27, 27, 0.4)',
  },
  NETWORK_LABEL_DEFAULT_PARAMS: {
    position: 'bottom-right',
    visible: true,
  },
  MAIN_VIDEO_CONTAINER_SETTINGS: {
    KEYS: {
      POSITION: 'position',
      VISIBILITY: 'visible',
      LEGACY_VISIBILITY: 'visibility',
      COLOR: 'color',
    },
  },
} as const;

export const CALL_ERROR = {
  CALL_ALREADY_INITIATED: {
    code: 'CALL_ALREADY_INITIATED',
    name: 'CALL_ALREADY_INITIATED',
    message: 'There is already call in progress',
    details: {},
  },
  ERROR_IN_CALLING: {
    code: 'CALL_IN_PROGRESS',
    name: 'CALL_ALREADY_INITIATED',
    message: 'There is already call in progress',
    details: {},
  },
  CANNOT_ACCEPT_CALL: {
    code: 'CALL_IN_PROGRESS',
    name: 'CALL_IN_PROGRESS',
    message: 'There is already a call in progress',
    details: {},
  },
  NOT_INITIALIZED: {
    code: 'NOT_INITIALIZED',
    name: 'NOT_INITIALIZED',
    message:
      'Please call the CometChat.init() method before calling any other methods related to CometChat.',
    details: {},
  },
  NOT_LOGGED_IN: {
    code: 'NOT_LOGGED_IN',
    name: 'NOT_LOGGED_IN',
    message: 'Please login before starting a call.',
    details: {},
  },
  SESSION_ID_REQUIRED: {
    code: 'SESSION_ID_REQUIRED',
    name: 'SESSION_ID_REQUIRED',
    message: 'Please make sure you are passing correct session id.',
    details: {},
  },
  CALL_SETTINGS_REQUIRED: {
    code: 'CALL_SETTINGS_REQUIRED',
    name: 'CALL_SETTINGS_REQUIRED',
    message: 'Please make sure you are passing the call settings object.',
    details: {},
  },
  JWT_NOT_FOUND: {
    code: 'JWT_NOT_FOUND',
    name: 'JWT_NOT_FOUND',
    message: 'There was some issue while fetching JWT from API.',
    details: {},
  },
};

export const REGION = {
  us: 'us',
  eu: 'eu',
  in: 'in',
  US: 'us',
  EU: 'eu',
  IN: 'in',
} as const;

export const API_ERROR_CODES = {
  AUTH_ERR_AUTH_TOKEN_NOT_FOUND: 'AUTH_ERR_AUTH_TOKEN_NOT_FOUND',
};

export const GENERAL_CONSTS = {
  REGION: {
    us: 'us',
    eu: 'eu',
    in: 'in',
    US: 'us',
    EU: 'eu',
    IN: 'in',
  },
};

export const GENERAL_ERROR = {
  GENERIC_EXCEPTION: {
    code: 'GENERIC_EXCEPTION',
  },
  INVALID_ARGUMENT_EXCEPTION: {
    code: 'INVALID_ARGUMENT_EXCEPTION',
  },
  API_ERROR: {
    code: 'API_ERROR',
  },
  UNKNOWN_API_ERROR: {
    code: 'UNKNOWN_API_ERROR',
    message:
      'There is an unknown issue with the API request. Please check your internet connection and verify the api call.',
  },
  INVALID_CALL_APP_SETTINGS: {
    code: 'INVALID_CALL_APP_SETTINGS',
    message_instance:
      'appSettings must be an instance of CallAppSettings class',
    message_app_id: 'Invalid app id, please check your appSettings',
    message_region: 'Invalid region, please check your appSettings',
    message_host: 'Invalid host, please check your appSettings',
  },
  INVALID_CALL_SETTINGS: {
    code: 'INVALID_CALL_SETTINGS',
    message_instance: 'callSettings must be an instance of CallSettings class',
  },
  INVALID_PRESENTER_SETTINGS: {
    code: 'INVALID_PRESENTER_SETTINGS',
    message_instance:
      'presenterSettings must be an instance of PresenterSettings class',
  },
  INVALID_ARGUMENT_EXCEPTION_CALL_TOKEN: {
    code: 'INVALID_ARGUMENT_EXCEPTION',
    message: 'callToken must be valid please verify.',
  },
  ERROR_PRESENTER_MODE: {
    code: 'ERROR_PRESENTER_MODE',
    message:
      'Presenter mode is disabled. To use presenter mode, please enable it from the CometChat Apps Dashboard',
  },
} as const;
